
export const types = {
    contactsGetAllContacts: '[contacts] get list all contacts',
    contactsGetListCustomers: '[contacts] get list customers',
    contactsGetListSuppliers: '[contacts] Get list suppliers',
    contactsGetListExecutives: '[contacts] Get list executives',
    contactsAddNewCustomer: '[contacts] add new customer',
    contactsAddNewSupplier: '[contacts] add new supplier',
    contactsGetListPersonas: '[contacts] Get list personas'
}